import { useState } from "react";
import BusinessEditModal from "./businessEditModal";
import { useDispatch } from "react-redux";
import { deleteBusinessDetails, updateBusinessDetails } from "../features/9_officeSpaceOtherBusinessDetails/officeSpaceOtherBusinessSlice";
import { formatPhoneNumber, formatDollarWithComma } from "../features/utils";


const BusinessList = ({businesses}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentBusiness, setCurrentBusiness] = useState(null);
    const dispatch = useDispatch();
    const [error, setError] = useState({
        cellNumber: '',
        officeNumber: '',
        email: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'contactNumber') {
            const formattedPhoneNumber = formatPhoneNumber(value);
            setCurrentBusiness({...currentBusiness, [name]: formattedPhoneNumber})
            setError({...error, [name]: ''});
        }
        else if (name === 'contactEmail') {
            setCurrentBusiness({...currentBusiness, [name]: value})
            setError({...error, [name]: ''});
        }
        else if (name === 'rentAmount') {
            setCurrentBusiness({...currentBusiness, [name]: formatDollarWithComma(value)})
            setError({...error, [name]: ''});
        }
        else {
            setCurrentBusiness({...currentBusiness, [name]: value});
        }
    }

    const handleBlur = (e) => {
        const { name, value } = e.target;
        if (name === 'contactNumber') {
            // Check if the number has 10 digits
            const rawNumbers = value.replace(/[^\d]/g, '');
            if (rawNumbers.length !== 10) {
                setError({...error, [name]: 'Please enter a valid phone number'});
            }
        }
        else if (name === 'contactEmail') {
            var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailPattern.test(value)) {
                setError({...error, [name]: 'Please enter a valid email address'});
            }
        }
        
      };

    const handleEdit = (business) => {
        setCurrentBusiness(business);
        setIsModalOpen(true);
      };

    const handleSave = (event) => {
        event.preventDefault();
        const isFormValid = Object.values(error).every((error) => error === '');    
        if (isFormValid) {
            dispatch(updateBusinessDetails(currentBusiness));
            setIsModalOpen(false); // Close the modal after saving changes
        }
      };

    const handleDelete = (business) => {
        dispatch(deleteBusinessDetails(business))
    }

    const handleClose = () => {
        setIsModalOpen(false);
      };
    
    return (
        <div className="bg-white  overflow-hidden ">
            <ul className="divide-y divide-gray-200">
                {businesses.map((business) => (
                    <li key={business.id} className="grid grid-cols-5 justify-between items-center gap-2 p-4 bg-white shadow-inner rounded-lg mb-2">
                            <p className="col-span-2 text-sm font-medium text-indigo-600 truncate">{business.name}</p>
                            <p className="col-span-1 text-sm text-gray-500 truncate">{business.industry}</p>
                            <p className="col-span-1 text-sm text-gray-500 truncate">{business.contactEmail}</p>
                            <div className="col-span-1 flex justify-end">
                            <button
                                onClick={() => handleEdit(business)}
                                className="text-sm  hover:bg-gray-300 py-2 px-4 rounded"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                    <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                                </svg>
                            </button>
                            <button
                                onClick={() => handleDelete(business)}
                                className="text-sm hover:bg-red-300 text-red-700 py-2 px-4 rounded"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
                                </svg>
                            </button>
                        </div>
                    </li>
                ))}
            </ul>
            <BusinessEditModal 
                    isOpen={isModalOpen} 
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    onClose={handleClose} 
                    onSave={handleSave} 
                    business={currentBusiness} 
                    errors={error}
                />
        </div>
    )
}

export default BusinessList;